import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'isPersianChars',
})
export class IsPersianCharsPipe implements PipeTransform {

  public static isPersian(str: string) {
    if (typeof str === 'string') {
      const PERSIAN_OR_ASCII = /[آ-ی]|([a-zA-Z])/;
      let measure;
      if ((measure = str.match(PERSIAN_OR_ASCII)) !== null) {
        return !measure[1];
      } else {
        return true;
      }
    }
    return;
  }

  transform(value: any): any {
    return IsPersianCharsPipe.isPersian(value);
  }
}
